const requirePath = function (img) {
  let S3_URL
  S3_URL = process.env.S3_URL
  return S3_URL + img
}

export default requirePath
